import sessionEmotions1 from '@/assets/images/sessionEmotions/1.svg';
import sessionEmotions2 from '@/assets/images/sessionEmotions/2.svg';
import sessionEmotions3 from '@/assets/images/sessionEmotions/3.svg';
import sessionEmotions4 from '@/assets/images/sessionEmotions/4.svg';
import sessionEmotions5 from '@/assets/images/sessionEmotions/5.svg';
import clsx from 'clsx';
import { motion } from 'motion/react';

export type Feeling = {
  src: string;
  feeling: number;
  isSelected?: boolean;
};

const initialFeelings: Feeling[] = [
  { src: sessionEmotions1, feeling: 1, isSelected: false },
  { src: sessionEmotions2, feeling: 2, isSelected: false },
  { src: sessionEmotions3, feeling: 3, isSelected: false },
  { src: sessionEmotions4, feeling: 4, isSelected: false },
  { src: sessionEmotions5, feeling: 5, isSelected: false }
];

const FeelingMeter = ({
  sentiment: feeling,
  setSentiment
}: {
  sentiment?: number;
  setSentiment: (feeling: number) => void;
}) => {
  return (
    <motion.div
      className="w-full"
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.2 }}
    >
      <div className="feeling-container flex justify-between items-center w-full rounded-3xl p-8 bg-slate-100 shadow-lg">
        {initialFeelings.map((item, index) => {
          return (
            <div
              className={clsx(
                'p-4 m-4 cursor-pointer',
                'transition-all duration-300',
                item.feeling === feeling && 'rounded-[20px] cursor-default',
                item.feeling === feeling && feeling > 3 && 'bg-green-200',
                item.feeling === feeling && feeling < 3 && 'bg-blue-200',
                item.feeling === feeling && feeling === 3 && 'bg-orange-200'
              )}
              key={index}
            >
              <img
                src={item.src}
                className="h-[39px] w-[39px] cursor-pointer select-none"
                onClick={() => {
                  setSentiment(item.feeling);
                }}
              />
            </div>
          );
        })}
      </div>
    </motion.div>
  );
};

export default FeelingMeter;
